import { S as Swiper, N as Navigation, a as Scrollbar, M as Mousewheel } from "./scrollbar.chunk.js";
const colectionButttonsSwiper = new Swiper("#jc-subcollection-swiper", {
  modules: [Navigation, Scrollbar, Mousewheel],
  slidesPerView: "auto",
  spaceBetween: 0,
  threshold: 10,
  direction: "horizontal",
  touch: true,
  mousewheel: {
    forceToAxis: true,
  },
  // scrollbar: {
  //   el: '#jc-subcollection-swiper-scroll',
  //   draggable: true,
  //   hide: true,
  // },
});
colectionButttonsSwiper.on("click", function (swiper, event) {
  var clickedIndex = swiper.clickedIndex;
  swiper.slideTo(clickedIndex);
});
const acc = document.querySelectorAll(".jc-filter-accordion-title");
acc.forEach((item) => {
  item.addEventListener("click", (e) => {
    e.target.closest(".jc-filter-accordion-title").classList.toggle("active");
    const paper = e.target.closest(".jc-filter-accordion");
    const content = paper.querySelector(".jc-filter-accordion-content");
    if (content.style.maxHeight != "0px") {
      content.style.maxHeight = "0px";
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
});
window.addEventListener("mousemove", accordionMove);
window.addEventListener("scroll", accordionMove);
window.addEventListener("resize", accordionMove);
function accordionMove() {
  document.querySelectorAll(".jc-filter-accordion-content").forEach((item) => {
    if (item.style.maxHeight != "0px") {
      item.style.maxHeight = item.scrollHeight + "px";
    }
  });
}
const collectionProductsTop = document.getElementById("jc-collection-list-top");
const collectionProductsTopOverlay = document.getElementById("jc-collection-list-top__overlay");
function moveFiltersBlock() {
  const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  if (viewportWidth < 992) {
    let filtersBlock = document.getElementById("jc-filters-wrap");
    collectionProductsTop.appendChild(filtersBlock);
  } else {
    let filtersBlock = document.getElementById("jc-filters-wrap");
    const jcFiltersBlock = document.getElementById("jc-filters");
    jcFiltersBlock.appendChild(filtersBlock);
    collectionProductsTop.classList.remove("active");
    collectionProductsTopOverlay?.classList.add("jc-hidden");
  }
}
const openButton = document.getElementById("jc-filters-wrap__toggle");
openButton.addEventListener("click", function () {
  if (window.innerWidth < 992) {
    collectionProductsTop.classList.add("active");
    collectionProductsTopOverlay?.classList.remove("jc-hidden");
    collectionProductsTop.scrollIntoView({ behavior: "smooth", block: "start" });
  }
});
const closeButton = document.querySelectorAll(".jc-hide-filter");
closeButton.forEach((btn) => {
  btn.addEventListener("click", function (e) {
    e.preventDefault();
    collectionProductsTop.classList.remove("active");
    collectionProductsTopOverlay.classList.add("jc-hidden");
  });
});
document.addEventListener("DOMContentLoaded", moveFiltersBlock);
window.addEventListener("resize", moveFiltersBlock);
const form = document.getElementById("subFiltersForm");
window.onload = function () {
  for (let i = 0; i < form.elements.length; i++) {
    let element = form.elements[i];
    element.addEventListener("change", handleChange);
  }
};
function handleChange(event) {
  let element = event.target;
  let nonEmptyElements = [];
  for (let i = 0; i < form.elements.length; i++) {
    element = form.elements[i];
    let queryItem = element.name + "=" + element.value;
    if (element.type === "checkbox" || element.type === "radio") {
      if (element.checked) {
        nonEmptyElements.push(queryItem);
      }
    }
  }
  let requestUrl = nonEmptyElements.join("&");
  handleFilters(requestUrl);
}
const subColections = document.querySelectorAll("[data-subcollection-handle]");
function handleFilters(newURL) {
  //demande de l'équipe de Yade: Toujours afficher les produits disponibles
  if (!newURL.includes("filter.v.availability")) {
    newURL += "&filter.v.availability=1";

    document.querySelectorAll("[jolly-card-id]").forEach((card) => {
      card.classList.remove("jc-filtered");
    });

    // subColections.forEach((subCollection) => {
    //   subCollection.classList.add("jc-subcollection-filtered");
    //   subCollection.classList.add("jc-hidden");
    //   let jolly_subcollection_handle = subCollection.dataset.subcollectionHandle;
    //   let parser = new DOMParser();
    //   fetch(window.location.origin + `/collections/${jolly_subcollection_handle}?${newURL}`).then((responce) => responce.text()).then((data) => {
    //     let parsedData = parser.parseFromString(data, "text/html");
    //     let newItems = parsedData.getElementById("collectionProducts").innerText;
    //     const subCollectionCard = subCollection.querySelectorAll("[jolly-card-id]");

    //     if (subCollectionCard.length == 0) {
    //       console.error('No cards in subcollection');
    //       return;
    //     }
    //     subCollectionCard.forEach((el) => {
    //       let cardFilter = el.getAttribute("jolly-card-id");
    //       if (newItems.indexOf(cardFilter) != -1) {
    //         el.classList.add("jc-filtered");
    //         el.closest("[data-subcollection-handle]").classList.remove("jc-hidden");
    //       } else {
    //         el.classList.remove("jc-filtered");
    //       }
    //     });
    //   });
    // });

    function fetchAllSubCollections(subCollectionsHandles) {
      return Promise.all(subCollectionsHandles.map((handle) => fetch(`${window.location.origin}/collections/${handle}?${newURL}`).then((response) => (response.ok ? response.text() : Promise.reject("Fetch failed")))));
    }

    function processSubCollections(subCollections) {
      const subCollectionsHandles = subCollections.map((subCollection) => subCollection.dataset.subcollectionHandle);

      fetchAllSubCollections(subCollectionsHandles)
        .then((responses) => {
          responses.forEach((data, index) => {
            let parser = new DOMParser();
            let parsedData = parser.parseFromString(data, "text/html");
            /**
             * @type {string}
             */
            let collectionItems = parsedData.querySelector("#collectionProducts").innerText;
            /**
             * @type {Array<string>}
             */
            let itemIds = collectionItems.split("@");

            const subCollection = subCollections[index];
            const subCollectionCards = subCollection.querySelectorAll("[jolly-card-id]");

            subCollectionCards.forEach((el) => {
              let cardFilter = el.getAttribute("jolly-card-id");
              if (itemIds.includes(cardFilter)) {
                el.classList.add("jc-filtered");
                el.classList.remove("jc-hidden");
                subCollection.classList.remove("jc-hidden");
              } else {
                el.classList.remove("jc-filtered");
                el.classList.add("jc-hidden");
              }
            });
          });
        })
        .catch((error) => console.error(error));
    }

    processSubCollections(Array.from(subColections));
  }

  const sectionHeader = document.querySelector(".header-group-container");
  const collectionListTop = document.getElementById("jc-collection-list-top");
  const sectionHeaderObserver = new MutationObserver((mutationsList, observer) => {
    for (let mutation of mutationsList) {
      if (mutation.type === "attributes" && mutation.attributeName === "class") {
        const sectionHeaderHeight = sectionHeader.offsetHeight;
        collectionListTop.offsetHeight;
        if (sectionHeader.querySelector(".section-header").classList.contains("shopify-section-header-hidden")) {
          collectionListTop.style.top = `0px`;
        } else {
          collectionListTop.style.top = `${sectionHeaderHeight}px`;
        }
      }
    }
  });
  sectionHeaderObserver.observe(sectionHeader, { attributes: true });
}
